// import Logo from '@/assets/logo.svg';

const ExternalWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <div className="flex w-full h-screen bg-gray-50 ">{children}</div>
    </>
  );
};

export default ExternalWrapper;
